import { PaymentMethodProvider } from '@sorare/core/src/__generated__/globalTypes';
import { useMangopayCreditCardsEnabled } from '@sorare/core/src/hooks/useMangopayCreditCardsEnabled';

export const useCardPaymentProvider = (
  cardPaymentProvider: PaymentMethodProvider | undefined,
  { isSecondary }: { isSecondary: boolean }
): PaymentMethodProvider => {
  const mangopayCreditCardsEnabled = useMangopayCreditCardsEnabled();

  if (cardPaymentProvider) return cardPaymentProvider;

  // Flows without the field (e.g. pack purchases) fall back to today's client rule
  // (USD → Stripe, else Mangopay; secondary always Mangopay).
  return mangopayCreditCardsEnabled || isSecondary
    ? PaymentMethodProvider.MANGOPAY
    : PaymentMethodProvider.STRIPE;
};
